<app-document-popup-project #document></app-document-popup-project>
<app-pay-popup-project #pay></app-pay-popup-project>
<app-frente-information #summary></app-frente-information>

<section>

  <div class="col-12  d-flex justify-content-between">
    <h2 class="text-left text-white px-5 my-4">Listado de clientes</h2>
    <div class="d-flex justify-content-center align-items-center">
      <button
          class="badge rounded-pill btn btn-outline-light mx-2"
          [routerLink]="['/pdg/client/create/']"
          
        >
          <i class="fa-solid fa-plus m-1 m-2 fs-6" aria-hidden="true"></i>
          <span class="m-2 fs-6">Crear Cliente </span>
          
        </button>
    </div>
  </div>
    <div class="container-fluid px-5">
      <div class="backgroundTable">
  
      
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes componente-importantes-from-popup">
          
          <ng-container *ngIf="ListClient.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="ListClient.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Nombre</th>
              <th class="text-white text-center">Ver Frente</th>
              <th class="text-white text-center">Opciones</th>
          </thead>

          <tbody>
            <tr *ngFor="let client of ListClient">
 
              <td class="text-center">{{client.name}}</td>
            
              <td class="text-center">
                <div class="col-auto"><span class="pointer " [routerLink]="['./../frente',client.id]" > 
                  <i class="fa-solid fa-eye fa-xl"></i></span>
                </div>
              </td>
             
              
              <td class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button [routerLink]="['/pdg/client/edit', client.id]" ngbDropdownItem>Editar</button>
                    <button (click)="stageDeleteClient(client.id)" ngbDropdownItem>Eliminar</button>             
                  </div>
                </div>
              </td>
   
            </tbody>
          </ng-container>
            </table>

          </div>
        </div>
  </section>
